export { default } from './PatientDevicesPopup';
